import { memo, useState, useEffect } from 'react';
import { View, Text, Pressable } from 'react-native';
import Slider from '@react-native-community/slider';
import { Entypo, Ionicons } from '@expo/vector-icons';
import { Audio } from 'expo-av';
import moment from 'moment';

import { colors } from "../Shared";
import RenderIf from '../RenderIf';

const wait = async (time: number) => new Promise((resolve) => setTimeout(resolve, time * 1000));

interface VoiceItemProps {
	url: string;
}

const VoiceItem = ({ url }: VoiceItemProps) => {
	if (url == '') {
		return <Text>Sin url para cargar audio</Text>;
	}

	const [isPlaying, setIsPlaying] = useState(false);
	const [track, setTrack] = useState<Audio.Sound>();
	const [time, setTime] = useState<string>('00:00');
	const [durationMili, setDurationMili] = useState<number>(0);
	const [barPosition, setBarPosition] = useState(0);

	useEffect(() => {
		loadTrack();
	}, []);

	useEffect(() => {
		loadTime();
	}, [track]);

	async function loadTime(): Promise<void> {
		if (!track) {
			return;
		}

		const status = await track.getStatusAsync();
		if(!status.isLoaded || !status.durationMillis) {
			await wait(0.2)
			return loadTime();
		}

		setDurationMili(status?.durationMillis || 0);
		const duration = moment.duration(status?.durationMillis);
		const minutes = duration.minutes() < 10 ? `0${duration.minutes()}` : duration.minutes();
		const seconds = duration.seconds() < 10 ? `0${duration.seconds()}` : duration.seconds();
		setTime(minutes + ':' + seconds);
	}

	async function loadTrack() {
		const { sound } = await Audio.Sound.createAsync({
			uri: url
		});

		setTrack(sound);
	}

	function play () {
		if (!track) {
			return;
		}
		
		setIsPlaying(true);
		track.playAsync();
		track._onPlaybackStatusUpdate = (status: any) => {
			if (!status) {
				return;
			}

			if (status.durationMillis == status.positionMillis) {
				setIsPlaying(false);
				setBarPosition(0);
				return;
			}

			setBarPosition(status.positionMillis / status.durationMillis);
		}
	}

	function pause () {
		if (!track) {
			return;
		}

		setIsPlaying(false);
		track.pauseAsync();
	}

	return (
		<View
			style={{
				minHeight: 10,
				marginVertical: 5,
				flexDirection: "row",
				transform: [{ scaleY: -1 }]
			}}
		>
			<View
				style={{
					borderRadius: 10,
					backgroundColor: colors.bg.medium,
					flexDirection: 'row',
					justifyContent: 'space-between',
					alignItems: 'center',
					padding: 10,
					width: 300
				}}
			>
				<RenderIf condition={!isPlaying}>
					<Pressable onPress={play}>
						<Entypo name="controller-play" size={32} color='rgba(0, 0, 0, .6)' />
					</Pressable>
				</RenderIf>

				<RenderIf condition={isPlaying}>
					<Pressable onPress={pause}>
						<Ionicons name="pause" size={32} color='rgba(0, 0, 0, .6)' />
					</Pressable>
				</RenderIf>

				<Slider
					style={{ width: '70%', height: 40 }}
					maximumTrackTintColor='#00000033'
					minimumValue={0}
					maximumValue={1}
					value={barPosition}
					onSlidingComplete={(value) => {
						if (!track) {
							return;
						}

						track.setPositionAsync(durationMili * value);
					}}
				/>

				<Text style={{ color: '#000' }}>{time}</Text>
			</View>
		</View>
	)
}

export default memo(VoiceItem);
